import { render, staticRenderFns } from "./BrandFilter.vue?vue&type=template&id=42db8f42&scoped=true&"
import script from "./BrandFilter.vue?vue&type=script&lang=js&"
export * from "./BrandFilter.vue?vue&type=script&lang=js&"
import style0 from "./BrandFilter.vue?vue&type=style&index=0&id=42db8f42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42db8f42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42db8f42')) {
      api.createRecord('42db8f42', component.options)
    } else {
      api.reload('42db8f42', component.options)
    }
    module.hot.accept("./BrandFilter.vue?vue&type=template&id=42db8f42&scoped=true&", function () {
      api.rerender('42db8f42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BrandFilter.vue"
export default component.exports